import { render, staticRenderFns } from "./advertisingDialog.vue?vue&type=template&id=3b2437ff"
import script from "./advertisingDialog.vue?vue&type=script&lang=ts"
export * from "./advertisingDialog.vue?vue&type=script&lang=ts"
import style0 from "./advertisingDialog.vue?vue&type=style&index=0&id=3b2437ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports